const dataJson = [
    {name: "吃啥", value: 800},
    {name: "cola-designer", value: 900},
    {name: "大屏设计器", value: 629},
    {name: "数据可视化", value: 888},
    {name: "后台管理", value: 777},
    {name: "动态数据源",value: 688},
    {name: "拖拽式设计",value: 588},
    {name: "VUE3",value: 516},
    {name: "数据报表",value:515},
    {name: "JAVA",value:483},
    {name: "Spring",value:462},
    {name: "GOOGLE",value:449},
    {name: "数据权限",value:429},
    {name: "3D可视化",value:407},
    {name: "机房管理",value:406},
    {name: "销售报表",value:406},
    {name: "运维一体化管理",value:386},
    {name: "云服务监控",value:385},
    {name: "3D报表",value:375},
    {name: "市容环卫",value:355},
    {name: "自然资源管理",value:355},
    {name: "粉尘污染",value:335},
    {name: "噪声污染",value:324},
    {name: "土地资源管理",value:304},
    {name: "物业服务与管理",value:304},
    {name: "医疗卫生",value:284},
    {name: "粉煤灰污染",value:284},
    {name: "占道",value:284},
    {name: "供热发展",value:254},
    {name: "农村土地规划管理",value:254},
    {name: "生活噪音",value:253},
    {name: "供热单位影响",value:253},
    {name: "城市供电",value:223},
    {name: "房屋质量与安全",value:223},
    {name: "大气污染",value:223},
    {name: "房屋安全",value:223},
    {name: "文化活动",value:223},
    {name: "拆迁管理",value:223},
    {name: "公共设施",value:223},
    {name: "供气质量",value:223},
    {name: "供电管理",value:223},
    {name: "燃气管理",value:152},
    {name: "教育管理",value:152},
    {name: "医疗纠纷",value:152},
    {name: "执法监督",value:152},
    {name: "设备安全",value:152},
    {name: "政务建设",value:152},
    {name: "县区、开发区",value:152},
    {name: "宏观经济",value:152},
    {name: "教育管理",value:112},
    {name: "社会保障",value:112},
    {name: "生活用水管理",value:112},
    {name: "物业服务与管理",value:112},
    {name: "分类列表",value:112},
    {name: "农业生产",value:112},
    {name: "二次供水问题",value:112},
    {name: "城市公共设施",value:92},
    {name: "拆迁政策咨询",value:92},
    {name: "物业服务",value:92},
    {name: "物业管理",value:92},
    {name: "社会保障保险管理",value:92},
    {name: "低保管理",value:92},
    {name: "文娱市场管理",value:72},
    {name: "城市交通秩序管理",value:72},
    {name: "执法争议",value:72},
    {name: "商业烟尘污染",value:72},
    {name: "占道堆放",value:71},
    {name: "地上设施",value:71},
    {name: "水质",value:71},
    {name: "无水",value:71},
    {name: "供热单位影响",value:71},
    {name: "人行道管理",value:71},
    {name: "主网原因",value:71},
    {name: "集中供热",value:71},
    {name: "客运管理",value:71},
    {name: "国有公交（大巴）管理",value:71},
    {name: "工业粉尘污染",value:71},
    {name: "治安案件",value:71},
    {name: "压力容器安全",value:71},
    {name: "身份证管理",value:71},
    {name: "群众健身",value: 42},
    {name: "工业排放污染",value: 42},
    {name: "破坏森林资源",value: 42},
    {name: "市场收费",value: 42},
    {name: "生产资金",value: 42},
    {name: "生产噪声",value: 42},
    {name: "农村低保",value: 42},
    {name: "劳动争议",value: 42},
    {name: "劳动合同争议",value: 42},
    {name: "劳动报酬与福利",value: 42},
    {name: "医疗事故",value:21},
    {name: "停供",value:21},
    {name: "基础教育",value:21},
    {name: "职业教育",value:21},
    {name: "物业资质管理",value:21},
    {name: "拆迁补偿",value:21},
    {name: "设施维护",value:21},
    {name: "市场外溢",value: 16},
    {name: "占道经营",value: 16},
    {name: "树木管理",value: 16},
    {name: "农村基础设施",value: 16},
    {name: "无水",value: 16},
    {name: "供气质量",value: 16},
    {name: "停气",value: 16},
    {name: "自由民主",value: 16},
    {name: "燃气管理",value: 16},
    {name: "市容环卫",value: 16},
    {name: "新闻传媒",value: 16},
    {name: "人才招聘",value: 16},
    {name: "市场环境",value: 16},
    {name: "行政事业收费",value: 16},
    {name: "食品安全与卫生",value: 16},
    {name: "城市交通",value: 16},
    {name: "房地产开发",value: 16},
    {name: "房屋配套问题",value: 16},
    {name: "物业服务",value: 16},
    {name: "物业管理",value: 16},
    {name: "占道",value: 16},
    {name: "园林绿化",value: 16},
    {name: "户籍管理及身份证",value: 16},
    {name: "公交运输管理",value: 16},
    {name: "公路（水路）交通",value: 16},
    {name: "房屋与图纸不符",value: 16},
    {name: "有线电视",value: 16},
    {name: "社会治安",value: 16},
    {name: "林业资源",value: 16},
    {name: "其他行政事业收费",value: 16},
    {name: "经营性收费",value: 16},
    {name: "食品安全与卫生",value: 16},
    {name: "体育活动",value: 16},
    {name: "有线电视安装及调试维护",value: 16},
    {name: "低保管理",value: 16},
    {name: "劳动争议",value: 16},
    {name: "社会福利及事务",value: 16},
    {name: "一次供水问题",value: 11}
]

export default {
    attribute:{
        color: ['#f65f4e','#f6c603','#31adfb','#5aed18','#09db9a','#0a94f5','#877bed','#ed09dd','#ed097f','#ed3b3b'],
        fontWeight:'normal',
        gridSize:4,
        shape:'circle',
        rotationStep:45,
        sizeRange:[10, 60],
        drawOutOfBound:false,
        maskImage:'',
        emphasis:{
            focus: true,
            textStyle: {
                textShadowBlur: 10,
                textShadowColor: '#fff'
            }
        },
        cptTableData: [{ "name": "维度", "value": "", "namekey": "name" },{ "name": "指标", "value": "", "namekey": "value" }]
    },
    cptDataForm:{dataText: JSON.stringify(dataJson),dataSource: 1, pollTime: 0},
}